import React, { useState } from 'react'

import PostRegistrationWelcome from './postRegistrationWelcome'
import * as S from './styles'
import Logo from './svg/logo.svg'
import UserSignupForm from './userSignupForm'

const FORM_STEPS = {
  USER_SIGNUP_FORM: 'userSignupForm',
  POST_REGISTRATION_WELCOME: 'postRegistrationWelcome'
}

const STEP_COMPONENTS = {
  [FORM_STEPS.USER_SIGNUP_FORM]: UserSignupForm,
  [FORM_STEPS.POST_REGISTRATION_WELCOME]: PostRegistrationWelcome
}

export default function ExpoSec() {
  const [step, setStep] = useState(FORM_STEPS.USER_SIGNUP_FORM)
  const [formData, setFormData] = useState({})

  document.addEventListener('DOMContentLoaded', () => {
    const chatBtn = document.querySelector('.smk-altu-button-chat')

    chatBtn.style.display = 'none'
    chatBtn.style.opacity = '0'
  })

  const handleStepChange = (nextStep, data = {}) => {
    setFormData((prev) => ({ ...prev, ...data }))
    setStep(nextStep)
  }

  const CurrentStepComponent = STEP_COMPONENTS[step]

  if (!CurrentStepComponent) return null

  const getStepProps = () => {
    switch (step) {
      case FORM_STEPS.USER_SIGNUP_FORM:
        return {
          onSubmit: (data) =>
            handleStepChange(FORM_STEPS.POST_REGISTRATION_WELCOME, data)
        }
      case FORM_STEPS.POST_REGISTRATION_WELCOME:
        return { formData }
      default:
        return {
          onSubmit: (data) =>
            handleStepChange(FORM_STEPS.POST_REGISTRATION_WELCOME, data)
        }
    }
  }

  return (
    <>
      <CurrentStepComponent {...getStepProps()} />
      <S.Logo src={Logo} alt="Logo" stepScreen={step} />
    </>
  )
}
